import { withSvgIcon } from './withSvgIcon';

export const ArrowToRight = withSvgIcon(
  <path
    d="M2 1H8M8 1V7M8 1L2 7"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="square"
  />,
  { viewBox: '0 0 9 9' },
);
